export enum SentryFlow {
    ADMIN_LOGIN = 'admin_login',
    TOKEN_REQUEST_KRAKEND = 'admin_token_request.krakend',
    TOKEN_REQUEST_ONECLICK = 'admin_token_request.oneclick',
    TOKEN_APPROVAL_KRAKEND = 'admin_token_approval.krakend',
    TOKEN_APPROVAL_ONECLICK = 'admin_token_approval.oneclick',
    APPLICATION_REQUEST = 'admin_application_request',
    APPLICATION_APPROVAL = 'admin_application_approval',
}

export enum AddPermissionWidgetType {
    Page,
    Action,
    Listing,
    Page_Filter,
    Page_Form,
    Listing_Filter,
    Form_Field,
    Listing_Action
}

export enum CompanyStatus {
    PENDING,
    SALES_APPROVED,
    FINANCIAL_APPROVED,
    FINANCIAL_DENIED,
}

export enum BranchName {
    ALL = 0,
    RO = 1,
    RS = 2,
    NL_EER = 3,
    NL_VEN = 4,
    NL_ROT = 5,
    GR = 6,
    UK_BRA = 7,
}

export enum TmsRoadApiStatus {
    UNKNOWN,
    CREATE_IN_PROGRESS,
    UPDATE_IN_PROGRESS,
    ERROR,
    SYNCED,
}
export enum TableType{
    COMPANIES,
    CONTACTS,
    ERP_CUSTOMERS,
    WAREHOUSEING_RECEPTION_RETURN,
    WAREHOUSEING_ORDERS,
    WAREHOUSEING_SIMPLIFY_RECEPTION_RETURN,
    WAREHOUSEING_SIMPLIFY_ORDERS,
    DOMESTIC_ROAD,
    INTERNATIONAL_ROAD,
    OCEAN,
    AIR,
    ERP_CUSTOMERS_INVOICE_OVERVIEW,
    ERP_CUSTOMERS_DOMESTIC_SHIPMENT_OVERVIEW,
    ERP_CUSTOMERS_INTERNATIONAL_SHIPMENT_OVERVIEW,
    COMPANY_USER,
    ERP_CUSTOMERS_SHIPMENT_SEA_OVERVIEW,
    ERP_CUSTOMERS_SHIPMENT_AIR_OVERVIEW,
    API_RESOURCE_FIELD,
    API_ROUTE_FIELD,
    KLG_USERS,
    EXCHANGE_RATES,
    COMPANY_FOR_ALL,
    ACCCOUNT_RECEIVABLES,
    LEGAL_HOLIDAYS,
    STRONGO_SHIPMENTS,
    APP_STATUSES,
    ERP_CUSTOMERS_SHIPMENT_STRONGO_OVERVIEW,
    KRAKEND_TOKENS,
    USER_SESSIONS,
    KLG_USER_SESSIONS,
    ONECLICK_TOKEN_DEMANDS,
    ONECLICK_TOKENS,
    KRAKEND_TOKEN_DEMANDS,
    APPLICATION_DEMANDS,
    APPLICATIONS,
    MCP_TOKENS,
    MCP_TOKEN_ACTIVITIES,
    NOTIFICATIONS,
    ALERTS,
    CLIENT_MCP_TOKENS,
    CLIENT_MCP_TOKEN_ACTIVITIES,
    CLEO_DOCUMENTS,
    APPLICATION_API_RESOURCE_FIELD,
    APPLICATION_API_ROUTE_FIELD,
    CLEO_INSIGHTS,
}

export enum CompanyBusinessLineType {
    ROAD_DOMESTIC = 1,
    OCEAN = 2,
    WAREHOUSING_SIMPLIFY = 3,
    WAREHOUSING = 4,
    ERP = 5,
    ROAD_INTERNATIONAL = 6,
    AIR = 7,
    STRONGO = 8,
}

export enum AuthorizedEmailApplication {
    AZURE = 1,
    AZURE_EMAIL = 2,
    AZURE_APP_KLG_USERS = 3,
    SHAREPOINT_CONTRACTS= 4,
}

export enum CompanyContractAddendumType {
    CLAUSE = 1,
    EXTENSION = 2,
    TERMINATION= 3,
}

export enum CompanyDocumentRenewalType {
    AUTOMATIC = 1,
    MANUAL = 2,
}

export enum CompanyAnnexType {
    TARIFF = 'Tariff',
    SERVICE = 'Service',
    GDPR = 'GDPR',
}